import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title:"PAPER联盟招商加盟"
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: {
      title:"关于我们 | PAPER联盟招商加盟"
    }
  },
  {
    path: '/product',
    name: 'Product',
    component: ()=> import('../views/Product'),
    meta: {
      title:"产品介绍 | PAPER联盟招商加盟"
    }
  },
  {
    path: '/joincase',
    name: 'JoinCase',
    component: ()=> import('../views/JoinCase'),
    meta: {
      title:"加盟案例 | PAPER联盟招商加盟"
    }
  },
  {
    path:'/industry',
    name:'Industry',
    component: ()=>import('../views/Industry'),
    meta: {
      title:"行业介绍 | PAPER联盟招商加盟"
    }
  },
  {
    path:'/contact',
    name:'Contact',
    component: ()=>import('../views/Contact'),
    meta: {
      title:"联系我们 | PAPER联盟招商加盟"
    }
  },
  {
    path:'/serve',
    name:'Serve',
    component: ()=>import('../views/Serve'),
    meta: {
      title:"服务市场 | PAPER联盟招商加盟"
    }
  }

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to,from,next)=>{
  if(to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
